// src/utils/hreflang.js
// Utility for managing hreflang tags for multilingual SEO
// Generates per-language alternate URLs with /:lang prefix

const LANGUAGES = ['en', 'fr', 'es', 'ar'];
const BASE_URL = 'https://humoraq.com';

/**
 * Add hreflang tags for the current page.
 * Each page gets 4 alternate links (one per language) + x-default.
 *
 * @param {string} currentPath - Current full path (e.g., '/fr/category/tech')
 */
export const addHreflangTags = (currentPath) => {
  // Remove existing hreflang tags
  const existingTags = document.querySelectorAll('link[rel="alternate"][hreflang]');
  existingTags.forEach(tag => tag.remove());

  // Strip the lang prefix to get the bare path
  const barePath = currentPath.replace(/^\/(en|fr|es|ar)/, '') || '';

  // Add hreflang for each language
  LANGUAGES.forEach(lang => {
    const link = document.createElement('link');
    link.rel = 'alternate';
    link.hreflang = lang;
    link.href = `${BASE_URL}/${lang}${barePath}`;
    document.head.appendChild(link);
  });

  // x-default points to /en version
  const defaultLink = document.createElement('link');
  defaultLink.rel = 'alternate';
  defaultLink.hreflang = 'x-default';
  defaultLink.href = `${BASE_URL}/en${barePath}`;
  document.head.appendChild(defaultLink);
};

/**
 * Update HTML lang attribute based on current language
 *
 * @param {string} lang - Language code ('en', 'fr', 'es', 'ar')
 */
export const updateHtmlLang = (lang) => {
  document.documentElement.setAttribute('lang', lang);
  document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
};
